module.exports = __webpack_public_path__ + "static/media/ic_location.93575457.svg";